import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import { Field } from 'react-final-form';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { composeValidators } from '../utils/validation';

const getMessage = (meta, formControlProps) => {
  if (meta.touched && meta.error) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.validation.${meta.error}`
    });
  } else {
    if (formControlProps && formControlProps.validationMessage) return formControlProps.validationMessage;
  }

  return null;
};

export const FinalFormField = ({
  render,
  formControlProps,
  fieldProps,
  validators
}) => {
  return /*#__PURE__*/_jsx(Field, Object.assign({}, fieldProps, {
    render: ({
      meta,
      input
    }) => /*#__PURE__*/_jsx(UIFormControl, Object.assign({}, formControlProps, {
      error: !!(meta.touched && meta.error),
      validationMessage: getMessage(meta, formControlProps),
      children: render(input)
    })),
    validate: validators && composeValidators(...validators)
  }));
};